import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearAuthError } from "../../../actions/app/global";
import { useHistory, useLocation } from "react-router-dom";

const Loader = props => {
  const { children } = props;

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  let isAuthError = useSelector(state => state.global.isAuthError);

  if (isAuthError) {
    if (location.pathname !== '/login') {
        history.push('/login');
    }

    dispatch(clearAuthError());
  }

  return (
    <>
      {children}
    </>
  );
};

export default Loader;
